import { DateAdapterBase } from '@rschedule/core';
import { Dates } from '@rschedule/core/generators';
import {
  serializeDataToJSON,
  ParseJSONError,
  registerJSONSerializerFn,
} from '@rschedule/json-tools';

Dates.prototype.toJSON = function serialize(opts = {}) {
  const json = {
    type: 'Dates',
    dates: this.adapters.map(adapter => adapter.toJSON()),
  };
  if (!opts.nested) json.timezone = this.timezone;
  serializeDataToJSON(this, json, opts);
  return json;
};
Dates.fromJSON = function parse(json, options = {}) {
  if (json.type !== 'Dates') {
    throw new ParseJSONError('Invalid Dates JSON');
  }
  return new Dates({
    dates: json.dates.map(date => DateAdapterBase.adapter.fromJSON(date)),
    data: typeof options.data === 'function' ? options.data(json) : json.data,
    timezone: options.timezone || json.timezone,
  });
};
registerJSONSerializerFn('Dates', Dates.fromJSON);
